goog.provide("shadow.js.shim.module$mime$types$other");
goog.provide("module$shadow_js_shim_module$mime$types$other");
shadow.js.shim.module$mime$types$other = shadow.js.nativeProvides["mime/types/other.js"] = shadow$bridge("mime/types/other.js");
module$shadow_js_shim_module$mime$types$other.default = shadow.js.shim.module$mime$types$other;
